import { createPropertySelectors, createSelector, Selector } from "@ngxs/store";
import { Build } from "@dis/models";
import { BUILDS_STATE_TOKEN, BuildsStateModel } from "./state";

export class BuildsSelectors {
  static slices = createPropertySelectors<BuildsStateModel>(BUILDS_STATE_TOKEN);

  /**
   *
   * @description Lazy version of the selector to work with signals
   * @param state
   * @returns
   */
  @Selector([BUILDS_STATE_TOKEN])
  static getById(state: BuildsStateModel) {
    return (id: string): Build | undefined => {
      return state.items.find(item => item.uid === id);
    }
  }

  static getByAssemblyNumber(assemblyNumber: string) {
    return createSelector([BUILDS_STATE_TOKEN], (state: BuildsStateModel): Build[] => {
      return state.items.filter(build => build.assemblyNumber === assemblyNumber);
    })
  }

  @Selector([BUILDS_STATE_TOKEN])
  static getByBuildNumber(state: BuildsStateModel) {
    return (buildNumber: string): Build | undefined => {
      return state.items.find(item => item.buildNumber === buildNumber);
    }
  }

  @Selector([BUILDS_STATE_TOKEN])
  static countRunsBySerialNumber(state: BuildsStateModel) {
    return (serialNumber: string) => {
      return state.items
      .filter(item => item.serialNumber === serialNumber && item.metadata?.booleanMetadata?.ranBoolean).length;
    }
  }

  // static getByBuildNumber(buildNumber: string) {
  //   return createSelector([BUILDS_STATE_TOKEN], (state: BuildsStateModel) => {
  //     return state.items.filter(build => build.buildNumber === buildNumber);
  //   })
  // }

  static getByJobNumber(jobNumber: string) {
    return createSelector([BUILDS_STATE_TOKEN], (state: BuildsStateModel): Build[] => {
      return [...state.items?.filter(build => build.jobNumber === jobNumber)].reverse()
    })
  }


  static getByJobUid(jobUid: string) {
    return createSelector([BUILDS_STATE_TOKEN], (state: BuildsStateModel): Build[] => {
      return [...state.items?.filter(build => build.jobUid === jobUid)].reverse()
    })
  }

  static getByToolType(toolType: string) {
    return createSelector([BUILDS_STATE_TOKEN], (state: BuildsStateModel): Build[] => {
      return state.items.filter(build => build.toolType === toolType);
    })
  }


  static getDownHoleBuildsOfJob(jobNumber: string) {
    return createSelector([BUILDS_STATE_TOKEN], (state: BuildsStateModel) => {
      return state.items.filter(item => item.statuses!.status === 'DOWNHOLE' && item.jobNumber === jobNumber).length > 0;
    })
  }
}
